<nav class="pagination-container" 
     [class.store]="theme() === 'store'" 
     [class.admin]="theme() === 'admin'"
     aria-label="Navegación de páginas">
     
  <button
    class="pagination-btn"
    [disabled]="currentPage() === 1"
    aria-label="Página anterior"
    (click)="onPageChange(currentPage() - 1)">
    &lt;
  </button>

  @for (item of pagesArray(); track $index) {
    @if (isEllipsis(item)) {
      <button
        class="pagination-number pagination-ellipsis"
        [attr.aria-label]="item.target === 1 ? 'Ir a la primera página' : 'Ir a la última página'"
        (click)="onPageChange(item.target)">
        &hellip;
      </button>
    } @else {
      <button
        class="pagination-number"
        [class.active]="currentPage() === item"
        [attr.aria-current]="currentPage() === item ? 'page' : null"
        [attr.aria-label]="'Página ' + item"
        (click)="onPageChange(item)">
        {{ item }}
      </button>
    }
  }

  <button
    class="pagination-btn"
    [disabled]="currentPage() === totalPages()"
    aria-label="Página siguiente"
    (click)="onPageChange(currentPage() + 1)">
    &gt;
  </button>
</nav>